import { FC, IDropdownObject, Props } from "./typings";
import styles from "./styles.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClose,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import SecondCheckbox from "components/SecondCheckbox";
import Button from "components/Button";
import HollowButton from "components/HollowButton";
import { useOnClickOutside } from "usehooks-ts";
import { useTranslation } from "react-i18next";

const Dropdown: FC<Props> = ({
  list,
  onChange,
  defaultValue,
  className = "",
  label,
  placeholder,
  allowNull = false,
  allowMulti = false,
  disableChange = false,
  noBorder = false,
  noBackground = false,
}) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [value, setValue] = useState<string | null>();

  const ref = useRef();

  useEffect(() => {
    if (defaultValue) {
      setValue(list.find((box) => box.value === defaultValue)?.name ?? "");
      return;
    }
    if (disableChange) return;

    if (list?.[0] && !allowNull) {
      setValue(list[0].name);
      return;
    }
    setValue("");
    // setValue(allowNull ? '' : list?.[0]?.name ?? '');
  }, []);

  useEffect(() => {
    if (defaultValue) {
      setValue(list.find((box) => box.value === defaultValue)?.name ?? "");
      return;
    }
    if (disableChange) return;
    if (list?.[0] && !allowNull) {
      setValue(list[0].name);
      return;
    }
    setValue("");
  }, [list, defaultValue]);

  const [multiSelect, setMultiSelect] = useState<IDropdownObject[]>([]);

  const handleChange = (box?: IDropdownObject) => {
    if (allowMulti) {
      setMultiSelect([...multiSelect!, box!]);
      return;
    }
    setValue(box?.name);
    onChange(box);
    setShow(false);
  };

  const handleMultiChange = () => {
    onChange(multiSelect);
    setValue(null);
    setMultiSelect([]);
    setShow(false);
  };

  const hasValue = !!value?.length;

  useOnClickOutside(ref, () => {
    if (!show) return;
    setShow(false);
  });

  return (
    <div
      ref={ref}
      className={`${styles.inputWrapper} ${className} ${
        hasValue ? styles.hasValue : ""
      }`}
    >
      {!hasValue && (
        // <div
        //   onClick={(e) => {
        //     setShow(!show);
        //     e.stopPropagation();
        //   }}
        //   className={`${styles.inputContent}`}
        // >
        //   {!hasValue ? placeholder ?? label : label}
        // </div>

        <div
          onClick={() => setShow(!show)}
          className={`${styles.input} ${noBorder && styles.brd} ${
            !noBackground && styles.bg
          }`}
        >
          <div className={styles.inputContent}>
            {!hasValue ? placeholder ?? label : label}
          </div>
          {!disableChange && (
            <FontAwesomeIcon
              className={styles.arrow}
              icon={show ? faChevronUp : faChevronDown}
            />
          )}
        </div>
      )}
      {hasValue && (
        <div
          onClick={() => setShow(!show)}
          className={`${styles.input} ${noBorder && styles.brd} ${
            !noBackground && styles.bg
          }`}
        >
          <div className={styles.inputContent}>{value}</div>
          <div className={styles.inputButtons}>
            {allowNull && (
              <FontAwesomeIcon
                className={styles.arrow}
                icon={faClose}
                onClick={(e) => {
                  handleChange(null);
                  e.stopPropagation();
                }}
              />
            )}
            {!disableChange && (
              <FontAwesomeIcon
                className={styles.arrow}
                icon={show ? faChevronUp : faChevronDown}
              />
            )}
          </div>
        </div>
      )}
      {show && !disableChange && (
        <div className={styles.listWrapper}>
          <div className={styles.list}>
            {list.map((box, index) => (
              <div
                key={"dropdown_option" + index}
                onClick={() => handleChange(box)}
                className={`${styles.box}`}
              >
                {allowMulti && (
                  <SecondCheckbox
                    onChange={() => {
                      handleChange(box);
                    }}
                    value={!!multiSelect.find((p) => p.value === box.value)}
                  />
                )}
                {box.Icon && <box.Icon />}
                {box.name}
              </div>
            ))}
          </div>
          {allowMulti && (
            <div className={styles.buttons}>
              <HollowButton text={t("common.cancel")} onClick={() => {}} />
              <Button text={t("common.add")} onClick={handleMultiChange} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
